import ActionSelector from '../../components/ActionSelector'
import { useModuleAction } from '../../hooks/useModuleAction'
import { type ReferralAction } from './constants'
import RemoveReferralForm from './RemoveReferralForm'
import SetReferralForm from './SetReferralForm'

export default function ReferralModule() {
  const { selectedAction, selectAction, isValidAction } =
    useModuleAction('referral')

  const formByAction = {
    set: SetReferralForm,
    remove: RemoveReferralForm,
  } satisfies Record<ReferralAction, React.ComponentType>

  const Form = selectedAction ? formByAction[selectedAction] : null

  if (!isValidAction) {
    return <ActionSelector module='referral' onSelectAction={selectAction} />
  }

  return <div className='space-y-4'>{Form && <Form />}</div>
}
